module.exports = __webpack_public_path__ + "static/img/8.88642889.jpg";